// externals
import { useSelector } from 'react-redux';

// libraries
import * as sharedStore from '@makemydeal/dr-shared-store';

// components
import CreditBureauWithScore from './CreditBureauWithScore';

interface CreditBureauInterstateProps {
    isLenderFormDirtyRef?: React.MutableRefObject<boolean>;
    showSoftPullPanel?: boolean;
}

export const CreditBureauInterstate = ({ isLenderFormDirtyRef, showSoftPullPanel }: CreditBureauInterstateProps) => {
    const isMvLiteEnabled = useSelector(sharedStore.dealerSelectors.isMvLiteEnabled);

    return !isMvLiteEnabled ? (
        <CreditBureauWithScore isLenderFormDirtyRef={isLenderFormDirtyRef} showSoftPullPanel={showSoftPullPanel} />
    ) : null;
};
